import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Tooltip,
  Pagination,
} from "@mui/material";
import SearchNotFound from "src/components/NotFound/SearchNotFound";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { UserListHead, UserListToolbar } from "src/components/_dashboard/user";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { htmlDecode } from "src/utils/convertHtml";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import { project_type } from "src/config/config";
import {
  deleteTransactionApi,
  transactionListApi,
} from "src/DAL/Transaction/transactionApi";
import moment from "moment";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import { convertCurrencyToSign, dd_date_format } from "src/utils/constant";
import TransactionsFilterNew from "./TransactionsFilterNew";
import FilteredChip from "src/components/FilteredChip";
import { countries } from "src/utils/country";

const TABLE_HEAD = [
  { id: "action", label: "Action", alignRight: false },
  { id: "number", label: "#", alignRight: false },
  { id: "email", label: "Member", alignRight: false },
  { id: "country", label: "Country", alignRight: false },
  { id: "type", label: "Type", alignRight: false },
  { id: "amount", label: "Amount", alignRight: false },
  { id: "tax", label: "Tax", alignRight: false },
  { id: "totalAmount", label: "Total Amount", alignRight: false },
  { id: "transactionDate", label: "Transaction Date", alignRight: false },
  { id: "created", label: "Created By", alignRight: false },
  { id: "type", label: "Transaction Type", alignRight: false },
  { id: "refUser", label: "Transaction Mode", alignRight: false },
];

function convertToTitleCase(variableName) {
  let formattedName = variableName.replace(/_/g, " ");

  formattedName = formattedName.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );

  return formattedName;
}
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));
export default function PaymentTransactionsList() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("number");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const [isAllDates, setIsAllDates] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [searchText, setSearchText] = useState("");

  const EMPTY_FILTER = {
    transaction_type: "all",
    sale_page: null,
    payment_plan: null,

    transaction_mode:
      project_type == "dev"
        ? "sandBox"
        : project_type != "dev"
        ? "live"
        : "all",
    transaction_status: [
      {
        name: "Succeeded",
        value: "succeeded",
        class: "succeeded_bg",
        chip_label: "Succeeded",
        chip_value: "succeeded",
      },
    ],
    start_date: null,
    end_date: null,
    date: null,
    payment_request: [],
    search_text: searchText,
    filter_by_plateform: null,
    country: null,
  };
  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [filterStateUpdated, setFilterStateUpdated] = useState(EMPTY_FILTER);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const handleChangeOthers = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
  };

  const searchFunction = () => {
    setPage(0);
    setPageCount(1);
    filterData.search_text = searchText;
    getcoachListing(filterData);
    localStorage.setItem("TransactionListSearch", JSON.stringify(filterData));
  };

  const handleClearFilter = () => {
    let clear_data = {
      ...EMPTY_FILTER,
      transaction_mode: "",
      transaction_status: [],
    };
    setFilterData(clear_data);
    getcoachListing(clear_data);
    localStorage.removeItem("TransactionListSearch");
  };

  const handleDeleteChip = (data) => {
    setPage(0);
    setPageCount(1);
    data.search_text = searchText;
    if (!data.date) {
      delete data.date;
      data.start_date = null;
      data.end_date = null;
      setIsAllDates(false);
    }
    getcoachListing(data);
    setFilterData(data);
    setFilterStateUpdated(data);
    localStorage.setItem("TransactionListSearch", JSON.stringify(data));
  };
  const getcoachListing = async (filter_data) => {
    handleCloseFilterDrawer();
    let postData = {
      search: filter_data?.search_text,
      transaction_type: filter_data?.transaction_type,
      transaction_status: filter_data?.transaction_status,
      transaction_mode: filter_data?.transaction_mode,
      start_date: filter_data?.start_date,
      end_date: filter_data?.end_date,
      platform: filter_data?.platform,
      sale_page: filter_data?.sale_page,
      payment_request: filter_data?.payment_request,
      country: filter_data?.country?.code,
    };

    if (postData.transaction_type == "sale_page") {
      postData.sale_page = filter_data?.sale_page?._id;
    } else {
      postData.sale_page = "";
    }

    if (postData.payment_plan) {
      postData.payment_plan = filter_data.payment_plan._id;
    }

    if (postData.transaction_type == "payment_request") {
      postData.payment_request = filter_data.payment_request.map((item) => {
        return item._id;
      });
    }

    if (postData.start_date) {
      postData.start_date = moment(filter_data.start_date).format("YYYY-MM-DD");
    }

    if (postData.end_date) {
      postData.end_date = moment(filter_data.end_date).format("YYYY-MM-DD");
    }

    if (postData.filter_by_plateform) {
      postData.filter_by_plateform = filter_data.filter_by_plateform.name;
    }

    if (postData.transaction_type !== "sale_page") {
      postData.sale_page = null;
    }
    if (postData.transaction_type !== "payment_request") {
      postData.payment_request = [];
    }
    if (postData.transaction_status.length > 0) {
      postData.transaction_status = postData.transaction_status.map((item) => {
        return item.value;
      });
    }

    setIsLoading(true);
    const result = await transactionListApi(page, rowsPerPage, postData);
    if (result.code === 200) {
      let chipData = { ...filter_data };
      if (chipData.start_date) {
        let date = `Start Date : ${dd_date_format(
          chipData.start_date,
        )} End Date :  ${dd_date_format(chipData.end_date)}`;
        chipData.date = {
          chip_label: date,
          chip_value: date,
        };
        delete chipData.start_date;
        delete chipData.end_date;
      }
      if (chipData.transaction_type == "all") {
        delete chipData.transaction_type;
      }
      if (chipData.transaction_type !== "sale_page") {
        delete chipData.sale_page;
        delete chipData.payment_plan;
      }
      if (chipData.transaction_type !== "payment_request") {
        delete chipData.payment_request;
      }
      if (chipData.search_text) {
        delete chipData.search_text;
      }
      if (chipData?.country?.label) {
        chipData.country = chipData?.country?.label;
      }
      setFilterStateUpdated(chipData);

      const data = result.transactions.map((transaction) => {
        let findCountry = countries.find((item) => {
          if (
            String(item.code) ==
            String(transaction?.shipping_object?.address?.country)
          ) {
            return item?.label;
          }
        });
        let reason_info = "No action required";
        if (transaction?.transaction_status == "payment_failed") {
          reason_info = "Transaction has been Failed";
        } else if (transaction?.transaction_status == "succeeded") {
          reason_info = "No action required";
        } else if (transaction?.transaction_status == "requires_action") {
          reason_info =
            "Transaction needs further action from the client to proceed";
        } else if (transaction?.transaction_status == "canceled") {
          reason_info = "This Transaction is Cancelled";
        }
        let statusTab = "Active";
        if (transaction?.transaction_status == "payment_failed") {
          statusTab = "Failed";
        } else if (transaction?.transaction_status == "succeeded") {
          statusTab = "Active";
        }
        return {
          ...transaction,
          id: transaction._id,
          amount: transaction.amount,
          email: transaction?.user_info?.email,
          transaction_type: transaction?.transaction_type,
          transaction_date: transaction?.transaction_date,
          currency: transaction?.currency,
          refUser: transaction?.affliliate,
          transaction_mode: transaction?.transaction_mode,
          status: transaction?.transaction_status,
          name: transaction?.user_name,
          total_amount: transaction?.deducted_amount
            ? transaction?.deducted_amount
            : 0,
          country: findCountry?.label,
          reason: reason_info,
          statusDate: statusTab,
        };
      });
      setTotalPages(result.total_pages);

      setUserList(data);
      setTotalCount(result.total_transactions);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };
  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const result = await deleteTransactionApi(deleteDoc.id);
    if (result.code === 200) {
      getcoachListing();
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };
  const handleFilterByName = (event) => {
    setSearchText(event.target.value);
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
    localStorage.setItem("member_page_number", newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);

    let findCountry = countries.find((item) => {
      if (String(item.label) == String(filterStateUpdated.country)) {
        return item;
      }
    });

    setFilterData(filterStateUpdated);
    setFilterData((values) => ({
      ...filterStateUpdated,
      country: findCountry,
    }));
  };
  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const MENU_OPTIONS = [
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];
  const headers = [
    { label: "Name", key: "first_name" },
    { label: "Country", key: "country" },
    { label: "Email", key: "email" },
    { label: "Amount", key: "amount" },
    { label: "Tax", key: "tax" },
    { label: "Total Amount", key: "total_amount" },
    { label: "Transaction Date", key: "transaction_date" },
    { label: "Transaction Mode", key: "transaction_mode" },
    { label: "Transaction Type", key: "transaction_type" },
  ];

  function download_csv_file(csv, csvFileData) {
    const headerRow = csv.map((column) => column.label);
    const csvRows = [headerRow];

    csvFileData.forEach((row) => {
      const dataRow = csv.map((column) => {
        const value = row[column.key] || "";
        return value.toString();
      });

      csvRows.push(dataRow);
    });

    const csvContent = csvRows.map((row) => row.join(",")).join("\n");

    const hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
    hiddenElement.target = "_blank";
    hiddenElement.download = "data.csv";
    hiddenElement.click();
  }

  const handleExportClick = () => {
    download_csv_file(headers, csvData);
  };

  useEffect(() => {
    let filter_data = EMPTY_FILTER;
    let find_filter = localStorage.getItem("TransactionListSearch");
    if (find_filter) {
      filter_data = JSON.parse(find_filter);
    }
    setFilterData(filter_data);
    setFilterStateUpdated(filter_data);
    getcoachListing(filter_data);
  }, [rowsPerPage, page]);

  useEffect(() => {
    const csvExportData = userList?.map((member) => {
      return {
        ...member,
        first_name: member?.name,
        email: member?.email,
        amount: convertCurrencyToSign(member?.currency) + member?.amount,

        transaction_date: member?.transaction_date
          ? moment(member?.transaction_date).format("DD-MM-YYYY")
          : "N/A",
        transaction_type:
          convertToTitleCase(
            htmlDecode(
              member?.transaction_type == "payment_plan"
                ? "sale_page"
                : member?.transaction_type,
            ) + ` | `,
          ) +
          (member?.sale_page ? member?.sale_page?.sale_page_title : "") +
          (member?.payment_request
            ? ` | ` + member?.payment_request?.request_title
            : "") +
          (member?.plan ? ` | ` + member?.plan?.plan_title : "") +
          (member?.transaction_request_type
            ? ` | ` + convertToTitleCase(member?.transaction_request_type)
            : ""),
      };
    });

    setCsvData(csvExportData);
  }, [userList]);

  const isUserNotFound = userList.length === 0;
  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />

      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-sm-12">
            <h2>Transactions</h2>
          </div>
          <div className="col-lg-4 col-sm-12 text-end">
            <button
              className="small-contained-button me-2 mt-1 mb-4"
              onClick={handleExportClick}
            >
              Export Csv &nbsp;&nbsp; <Icon icon={"ic:outline-file-download"} />
            </button>
            <button
              className="small-contained-button me-2 mt-1 mb-4"
              onClick={handleOpenFilterDrawer}
            >
              Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
            </button>
          </div>
        </div>

        <FilteredChip
          data={filterStateUpdated}
          tempState={filterData}
          EMPTY_FILTER={EMPTY_FILTER}
          onDeleteChip={handleDeleteChip}
          onClear={handleClearFilter}
        />

        <Card style={{ overflowX: "auto" }}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column align-items-start">
              <TablePagination
                rowsPerPageOptions={[5, 10, 20, 50]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />

              <Pagination
                count={totalPages + 1}
                page={pageCount}
                defaultPage={0}
                onChange={handleChangePages}
                className="pagination-style"
              />
            </div>
            <div className="d-flex align-items-center">
              <UserListToolbar
                numSelected={selected.length}
                filterName={searchText}
                onFilterName={handleFilterByName}
                onSearch={searchFunction}
              />
              <button
                onClick={() => searchFunction()}
                className="small-contained-button me-3 mb-1"
              >
                Search
              </button>
            </div>
          </div>

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={userList.length}
                numSelected={selected.length}
              />
              <TableBody>
                {userList &&
                  userList.map((row, i) => {
                    const {
                      id,
                      name,
                      status,
                      amount,
                      transaction_date,
                      currency,
                      transaction_type,
                      created_by,
                      transaction_mode,
                      transaction_request_type,
                      payment_request,
                      sale_page,
                      plan,
                      user_info,
                      tax,
                      total_amount,
                      reason,
                      country,
                    } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="action-in-table-width"
                        >
                          <CustomPopoverSection
                            menu={MENU_OPTIONS}
                            data={row}
                          />
                        </TableCell>
                        <TableCell
                          align="left"
                          className="action-in-table-width"
                        >
                          {page * rowsPerPage + (i + 1)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0}
                          >
                            <Typography variant="subtitle2" noWrap>
                              <Tooltip
                                title={`${convertToTitleCase(
                                  status,
                                )} : ${reason}`}
                              >
                                <FiberManualRecordIcon
                                  sx={{
                                    height: 20,
                                    width: 20,
                                    // color: "green",
                                    color:
                                      status == "succeeded"
                                        ? "#046307"
                                        : status == "canceled"
                                        ? "#04abbb"
                                        : status == "requires_action"
                                        ? "#163dbd"
                                        : status == "payment_failed"
                                        ? "#4b0505"
                                        : "",
                                  }}
                                />
                              </Tooltip>
                              {htmlDecode(
                                user_info?.name ? user_info?.name : "N/A",
                              )}{" "}
                              (
                              {htmlDecode(
                                user_info?.email ? user_info?.email : "N/A",
                              )}
                              )
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {country}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {user_info?.user_type == "member_user"
                            ? "Member"
                            : "Coach"}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="text-nowrap"
                        >
                          {convertCurrencyToSign(currency)} {amount}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="text-nowrap"
                        >
                          {tax ? tax : 0}%
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="text-nowrap"
                        >
                          {convertCurrencyToSign(currency)}{" "}
                          {total_amount.toFixed(2)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Typography className="text-nowrap">
                            {transaction_date
                              ? moment(transaction_date).format(
                                  "DD-MM-YYYY hh:mm A",
                                )
                              : "N/A"}
                          </Typography>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {created_by ? convertToTitleCase(created_by) : "N/A"}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Typography variant="subtitle2" noWrap>
                            {convertToTitleCase(
                              htmlDecode(
                                transaction_type == "payment_plan"
                                  ? "sale_page"
                                  : transaction_type,
                              ),
                            )}{" "}
                            ( {sale_page && sale_page?.sale_page_title + ` | `}
                            {payment_request &&
                              payment_request?.request_title + ` | `}
                            {plan && plan?.plan_title + ` | `}
                            {transaction_request_type &&
                              convertToTitleCase(transaction_request_type)}{" "}
                            )
                          </Typography>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {transaction_mode}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </div>
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={handleCloseFilterDrawer}
        pageTitle="Filters"
        componentToPassDown={
          <TransactionsFilterNew
            filterData={filterData}
            isAllDates={isAllDates}
            setIsAllDates={setIsAllDates}
            handleClearFilter={handleClearFilter}
            handleChangeOthers={handleChangeOthers}
            searchSubmitFilter={searchFunction}
            setFilterData={setFilterData}
          />
        }
      />
    </>
  );
}
